import React, { useState } from 'react';
import { requiresAiSharingConsent } from '@/lib/appDistribution';
import { useAuthStore } from '@/store/auth';
import { useAiSharingConsent } from '@/store/aiSharingConsent';
import SettingsSection from '@/components/SettingsSection';
import Text from '@/components/Typography/Text';
import Button from '@/components/Buttons/Button';

export default function AiSharingSettings() {
  const accountId = useAuthStore(state => state.user?.id);
  const choose = useAiSharingConsent(state => state.choose);
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  if (!requiresAiSharingConsent()) return null;
  return <SettingsSection title="AI data sharing" subtitle="You allowed relevant prompts, files, voice and task context to be shared with the AI providers handling your requests. Turning this off blocks new requests on this device. Stop existing tasks and schedules separately.">
    <Button text="Turn off AI data sharing" variant="secondary" isDisabled={busy} onPress={async () => {
      setBusy(true); setError('');
      try {
        require('@/store/voiceMode').useVoiceModeStore.getState().actions.stopVoiceMode();
        await choose(accountId, false);
      } catch (_) { setError('Unable to save your choice. Please try again.'); }
      finally { setBusy(false); }
    }} />
    {!!error && <Text color="danger" accessibilityRole="alert">{error}</Text>}
  </SettingsSection>;
}
